'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _dec, _class, _class2, _temp;

var _reactBootstrap = require('react-bootstrap');

var _redux = require('redux');

var _components2 = require('components');

var _docs = require('redux/modules/docs');

var _utils = require('../../../api/actions/Db/utils');

var _reactRedux = require('react-redux');

var _info = require('redux/modules/info');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
  PlaylistBtn: {
    displayName: 'PlaylistBtn'
  }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
  filename: '/home/Devel/web/productionRc/Agama2016/src/components/PlaylistBtn/PlaylistBtn.js',
  components: _components,
  locals: [],
  imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
  return function (Component) {
    return _reactTransformCatchErrors2(Component, id);
  };
}
// import Swipeable from 'react-swipeable';
// eslint-disable-line

// import {SongToAgamaConverter} from './AgamaText';


// import { changeSongText } from 'redux/modules/docs';
// import {toArray} from '../../../api/actions/Db/utils';

var PlaylistBtn = _wrapComponent('PlaylistBtn')((_dec = (0, _reactRedux.connect)(function (state) {
  return { docs: state.docs, info: state.info.data, authState: state.auth };
}, function (dispatch) {
  return (0, _redux.bindActionCreators)({ setUiProps: _info.setUiProps, createPlaylist: _docs.createPlaylist, setPlaylist: _docs.setPlaylist, panelVisibleToSide: _info.panelVisibleToSide }, dispatch);
}), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(PlaylistBtn, _Component);

  function PlaylistBtn() {
    var _ref;

    (0, _classCallCheck3.default)(this, PlaylistBtn);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var _this = (0, _possibleConstructorReturn3.default)(this, (_ref = PlaylistBtn.__proto__ || (0, _getPrototypeOf2.default)(PlaylistBtn)).call.apply(_ref, [this].concat(args)));

    _this.state = { value: '' };
    return _this;
  }

  (0, _createClass3.default)(PlaylistBtn, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          docs = _props.docs,
          xid = _props.xid,
          versionId = _props.versionId,
          setPlaylist = _props.setPlaylist,
          createPlaylist = _props.createPlaylist,
          authState = _props.authState; // eslint-disable-line no-shadow

      var playLists = docs.playLists;
      var user = authState.user;

      var editDisabled = versionId ? true : false;

      // console.log('playlist of user' + user);
      var rows = (playLists || []).map(function (item, keyIndex) {
        var playListInfo = (0, _docs.getPlaylistInfo)(docs, item.id, xid);
        return _react3.default.createElement(
          'tr',
          { key: keyIndex },
          _react3.default.createElement(
            'td',
            null,
            _react3.default.createElement(
              'label',
              { style: { cursor: playListInfo.exists ? 'default' : 'cell' }, htmlFor: 'chb__' + item.id },
              item.name
            ),
            ' [',
            playListInfo.total,
            '] '
          ),
          _react3.default.createElement(
            'td',
            null,
            _react3.default.createElement('input', { type: 'checkbox', id: 'chb__' + item.id, onClick: function onClick() {
                return setPlaylist(item.id, xid, playListInfo.exists ? 'remove' : 'add');
              }, checked: playListInfo.exists })
          )
        );
      });

      var addToPlaylistBtn = _react3.default.createElement(
        _reactBootstrap.Button,
        { bsStyle: 'primary', onClick: function onClick() {
            return _this2.setState({ open: !_this2.state.open });
          } },
        _react3.default.createElement(_reactBootstrap.Glyphicon, { glyph: 'heart' }),
        ' P\u0159idat do playlistu ',
        _react3.default.createElement(_reactBootstrap.Glyphicon, { glyph: this.state.open ? 'triangle-top' : 'triangle-bottom' })
      );

      if (!user) {
        return _react3.default.createElement(
          'span',
          null,
          addToPlaylistBtn,
          _react3.default.createElement(
            _reactBootstrap.Collapse,
            { 'in': this.state.open },
            _react3.default.createElement(
              'div',
              null,
              ' ',
              _react3.default.createElement(
                'span',
                null,
                'Pro vytv\xE1\u0159en\xED playlistu se pros\xEDm nejprve p\u0159ihla\u0161te'
              )
            )
          )
        );
      }
      if (editDisabled) {
        return _react3.default.createElement(
          'span',
          null,
          addToPlaylistBtn,
          _react3.default.createElement(
            _reactBootstrap.Collapse,
            { 'in': this.state.open },
            _react3.default.createElement(
              'div',
              null,
              ' ',
              _react3.default.createElement(
                'span',
                null,
                'Do playlistu nelze p\u0159id\xE1vat archivn\xED z\xE1znamy'
              )
            )
          )
        );
      }

      var getPlaylistName = function getPlaylistName() {
        var name = _this2.state.value.trim();
        if (name === '') name = 'Playlist ' + ((playLists || []).length + 1);
        return name;
      };
      // custom cursor : http://stackoverflow.com/questions/24093263/set-font-awesome-icons-as-cursor-is-this-possible - ne pro IE!!
      return _react3.default.createElement(
        'span',
        null,
        addToPlaylistBtn,
        _react3.default.createElement(
          _reactBootstrap.Collapse,
          { 'in': this.state.open },
          _react3.default.createElement(
            'div',
            null,
            ' ',
            _react3.default.createElement(
              'table',
              { className: 'table table-striped' },
              _react3.default.createElement(
                'thead',
                null,
                _react3.default.createElement(
                  'tr',
                  null,
                  _react3.default.createElement(
                    'th',
                    null,
                    'Vytvo\u0159it nov\xFD playlist'
                  ),
                  _react3.default.createElement(
                    'th',
                    null,
                    '\xA0'
                  )
                )
              ),
              _react3.default.createElement(
                'tbody',
                null,
                _react3.default.createElement(
                  'tr',
                  null,
                  _react3.default.createElement(
                    'td',
                    null,
                    _react3.default.createElement('input', { value: this.state.value, onChange: function onChange(evt) {
                        return _this2.setState({ value: (0, _utils.secureTextNice)(evt.target.value) });
                      } })
                  ),
                  _react3.default.createElement(
                    'td',
                    null,
                    _react3.default.createElement(
                      'span',
                      null,
                      _react3.default.createElement(_components2.ToolButton, { glyphIconName: 'plus', inGroup: true, onClick: function onClick() {
                          createPlaylist(getPlaylistName());_this2.setState({ value: '' });
                        } })
                    )
                  )
                )
              )
            ),
            _react3.default.createElement(
              'table',
              { className: 'table table-striped' },
              _react3.default.createElement(
                'thead',
                null,
                _react3.default.createElement(
                  'tr',
                  null,
                  _react3.default.createElement(
                    'th',
                    null,
                    'Seznam playlist\u016F'
                  ),
                  _react3.default.createElement(
                    'th',
                    null,
                    'Je sou\u010D\xE1st\xED ?'
                  )
                )
              ),
              _react3.default.createElement(
                'tbody',
                null,
                rows
              )
            )
          )
        )
      );
    }
  }]);
  return PlaylistBtn;
}(_react2.Component), _class2.propTypes = {
  docs: _react2.PropTypes.object,
  info: _react2.PropTypes.object,
  authState: _react2.PropTypes.object,
  xid: _react2.PropTypes.string.isRequired,
  versionId: _react2.PropTypes.string,
  setUiProps: _react2.PropTypes.func.isRequired,
  setPlaylist: _react2.PropTypes.func.isRequired,
  createPlaylist: _react2.PropTypes.func.isRequired
}, _temp)) || _class));

exports.default = PlaylistBtn;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/PlaylistBtn/PlaylistBtn.js
// module id = 1187
// module chunks = 0